export default {
  init() {
  
    
    //Search form
    document.getElementById('vacature-search').focus();

    $('#vacature-search').keyup(delay(function () {
      console.log('Letters ingetypt! :', this.value);

      var $vakgebieden    = $('.vakgebied input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $werkervaringen = $('.werkervaring input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $denkniveau     = $('.denkniveau input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $functie        = $('.Functie input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $s   = this.value;
      
      var $number = $('.ajax_content').attr('data-number');


      //ajax call
      actionAjax($number, $vakgebieden, $werkervaringen, $denkniveau, $functie, $s, 'dev_load_vacatures');

    }, 500));

    $('#searchform').submit(function(e) {
      e.preventDefault();
    });


    function delay(callback, ms) {
      var timer = 0;
      return function() {
        var context = this, args = arguments;

        //kijken of het veld net leeg is gegooid
        if ($(this).val() == '') { 

          //vul dan de lege waarden in 
          var $vakgebieden = $('.vakgebied input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
          var $werkervaringen = $('.werkervaring input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
          var $denkniveau = $('.denkniveau input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
          var $functie = $('.Functie input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
          var $s =  $('#vacature-search').val(); 
    
          var $number = $('.ajax_content').attr('data-number');
          //ajax call
          actionAjax($number, $vakgebieden, $werkervaringen, $denkniveau, $functie, $s, 'dev_load_vacatures');
          
        }
        //anders vertraagd reageren
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    }

    // click to search forms
    $('input[type="checkbox"]').change(function () {
     
      // haal bij elke verandering van een checkbox, alle aangevinkte items op
      //Dat moet dus per categorie worden gedaan en doorgegeven aan de AJAX call

      var $vakgebieden = $('.vakgebied input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $werkervaringen = $('.werkervaring input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $denkniveau = $('.denkniveau input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $functie = $('.Functie input[type="checkbox"]:checked').map(function () {return $(this).attr('data-slug');}).get().join(',');
      var $s =  $('#vacature-search').val(); 

      var $number = $('.ajax_content').attr('data-number');
      //ajax call
      console.log('Werkervaring ='+$werkervaringen);

      actionAjax($number, $vakgebieden, $werkervaringen, $denkniveau, $functie, $s, 'dev_load_vacatures');
  });

  function actionAjax($number = -1, $vakgebieden = '', $werkervaringen = '', $denkniveau = '', $functie = '', $s = '', $action = '', $page = 1) {
      const ajax_url = window.dev_ajax.ajax_url || false;
      // console.log($vakgebieden);
      if (ajax_url) {
          $.ajax({
              method: 'POST',
              url: ajax_url,
              data: {number: $number, vakgebied : $vakgebieden, werkervaring : $werkervaringen, denkniveau : $denkniveau, functie : $functie , action: $action, s: $s, page: $page},
              beforeSend: function() {
                  $('#loading').show();
              },
              success: function (result) {
                  $('.vacancy-list').html(result);
                  $('#loading').hide();
                  scrollToTop();
                  popOver();
              },
          });
      }

      function scrollToTop() {
        var body = $('html, body');
        body.stop().animate({scrollTop: ($('.vacancy-list').offset().top-300)}, 400, 'swing');
    }

      function popOver() {
        $('[data-toggle="popover"]').popover().click(function( event ) {
          event.preventDefault();
          if (this.firstElementChild.alt == 'toon korte samenvatting') {
            this.firstElementChild.setAttribute('alt','sluit korte samenvatting');
          } else {
            this.firstElementChild.setAttribute('alt','toon korte samenvatting');
          }
        });
    }

  }
 
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/vacatures.js